var LoadScript = (function ($) {
    return {
        init: function () {
            //"use strict";
            //$(document).ready(function () { 
            //function LoadScript() {
            /*==Left Navigation Accordion ==*/
            if ($.fn.dcAccordion) {
                $('#nav-accordion').dcAccordion({
                    eventType: 'click',
                    autoClose: true,
                    saveState: true,
                    disableLink: true,
                    speed: 'slow',
                    showCount: false,
                    autoExpand: true,
                    classExpand: 'dcjq-current-parent'
                });
            }
            /*==Slim Scroll ==*/
            if ($.fn.slimScroll) {
                $('.event-list').slimscroll({
                    height: '305px',
                    wheelStep: 20
                });
                $('.conversation-list').slimscroll({
                    height: '360px',
                    wheelStep: 35
                });
                $('.to-do-list').slimscroll({
                    height: '300px',
                    wheelStep: 35
                });
            }
            /*==Nice Scroll ==*/
            if ($.fn.niceScroll) {
                $(".leftside-navigation").niceScroll({
                    cursorcolor: "#1FB5AD",
                    cursorborder: "0px solid #fff",
                    cursorborderradius: "0px",
                    cursorwidth: "3px"
                });
                $(".leftside-navigation").getNiceScroll().resize();
                if ($('#sidebar').hasClass('hide-left-bar')) {
                    $(".leftside-navigation").getNiceScroll().hide();
                }
                $(".leftside-navigation").getNiceScroll().show();
                $(".right-stat-bar").niceScroll({
                    cursorcolor: "#1FB5AD",
                    cursorborder: "0px solid #fff",
                    cursorborderradius: "0px",
                    cursorwidth: "3px"
                });
            }
            /*==Easy Pie chart ==*/
            if ($.fn.easyPieChart) {
                $('.notification-pie-chart').easyPieChart({
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    },
                    barColor: "#39b6ac",
                    lineWidth: 3,
                    size: 50,
                    trackColor: "#efefef",
                    scaleColor: "#cccccc"
                });
                $('.pc-epie-chart').easyPieChart({
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    },
                    barColor: "#5bc6f0",
                    lineWidth: 3,
                    size: 50,
                    trackColor: "#32323a",
                    scaleColor: "#cccccc"
                });
            }
            /*== SPARKLINE==*/
            if ($.fn.sparkline) {
                $(".d-pending").sparkline([3, 1], {
                    type: 'pie',
                    width: '40',
                    height: '40',
                    sliceColors: ['#e1e1e1', '#8175c9']
                });
                var sparkLine = function () {
                    $(".sparkline").each(function () {
                        var $data = $(this).data();
                        ($data.type == 'pie') && $data.sliceColors && ($data.sliceColors = eval($data.sliceColors));
                        ($data.type == 'bar') && $data.stackedBarColor && ($data.stackedBarColor = eval($data.stackedBarColor));
                        $data.valueSpots = {
                            '0:': $data.spotColor
                        };
                        $(this).sparkline($data.data || "html", $data);
                        if ($(this).data("compositeData")) {
                            $spdata.composite = true;
                            $spdata.minSpotColor = false;
                            $spdata.maxSpotColor = false;
                            $spdata.valueSpots = {
                                '0:': $spdata.spotColor
                            };
                            $(this).sparkline($(this).data("compositeData"), $spdata);
                        }
                        ;
                    });
                };
                var sparkResize;
                $(window).resize(function (e) {
                    clearTimeout(sparkResize);
                    sparkResize = setTimeout(function () {
                        sparkLine(true);
                    }, 500);
                });
                sparkLine(false);
            }
            if ($.fn.plot) {
                var datatPie = [30, 50];
                // DONUT
                $.plot($(".target-sell"), datatPie, {
                    series: {
                        pie: {
                            innerRadius: 0.6,
                            show: true,
                            label: {
                                show: false
                            },
                            stroke: {
                                width: .01,
                                color: '#fff'
                            }
                        }
                    },
                    legend: {
                        show: true
                    },
                    grid: {
                        hoverable: true,
                        clickable: true
                    },
                    colors: ["#ff6d60", "#cbcdd9"]
                });
            }
            /*==Collapsible==*/
            $('.widget-head').click(function (e) {
                var widgetElem = $(this).children('.widget-collapse').children('i');
                $(this)
                    .next('.widget-container')
                    .slideToggle('slow');
                if ($(widgetElem).hasClass('ico-minus')) {
                    $(widgetElem).removeClass('ico-minus');
                    $(widgetElem).addClass('ico-plus');
                }
                else {
                    $(widgetElem).removeClass('ico-plus');
                    $(widgetElem).addClass('ico-minus');
                }
                e.preventDefault();
            });
            /*==Sidebar Toggle==*/
            $(".leftside-navigation .sub-menu > a").click(function () {
                var o = ($(this).offset());
                var diff = 80 - o.top;
                if (diff > 0)
                    $(".leftside-navigation").scrollTo("-=" + Math.abs(diff), 500);
                else
                    $(".leftside-navigation").scrollTo("+=" + Math.abs(diff), 500);
            });
            $(document).off("click", '#main-content, body').on("click", '#main-content, body', function (e) {
                if ($('#sidebar').hasClass('hide-left-bar')) {
                    $(".leftside-navigation").getNiceScroll().hide();
                    $('#sidebar').removeClass('hide-left-bar');
                }
            });
            $(document).off("click", '.sidebar-toggle-box .fa-bars').on("click", '.sidebar-toggle-box .fa-bars', function (e) {
                $(".leftside-navigation").niceScroll({
                    cursorcolor: "#1FB5AD",
                    cursorborder: "0px solid #fff",
                    cursorborderradius: "0px",
                    cursorwidth: "3px"
                });
                $('#sidebar').toggleClass('hide-left-bar');
                if ($('#sidebar').hasClass('hide-left-bar')) {
                    $(".leftside-navigation").getNiceScroll().hide();
                }
                $(".leftside-navigation").getNiceScroll().show();
                $('#main-content').toggleClass('merge-left');
                e.stopPropagation();
                if ($('#container').hasClass('open-right-panel')) {
                    $('#container').removeClass('open-right-panel');
                }
                if ($('.right-sidebar').hasClass('open-right-bar')) {
                    $('.right-sidebar').removeClass('open-right-bar');
                }
                if ($('.header').hasClass('merge-header')) {
                    $('.header').removeClass('merge-header');
                }
            });
            $(document).off("click", '.slide').on("click", '.slide', function (e) {
                $('#sidebar').toggleClass('hide-left-bar');
            });
            $('.toggle-right-box .fa-bars').click(function (e) {
                $('#container').toggleClass('open-right-panel');
                $('.right-sidebar').toggleClass('open-right-bar');
                $('.header').toggleClass('merge-header');
                e.stopPropagation();
            });
            $('.header,#main-content,#sidebar').click(function () {
                if ($('#container').hasClass('open-right-panel')) {
                    $('#container').removeClass('open-right-panel');
                }
                if ($('.right-sidebar').hasClass('open-right-bar')) {
                    $('.right-sidebar').removeClass('open-right-bar');
                }
                if ($('.header').hasClass('merge-header')) {
                    $('.header').removeClass('merge-header');
                }
            });
            $('.panel .tools .fa').click(function () {
                var el = $(this).parents(".panel").children(".panel-body");
                if ($(this).hasClass("fa-chevron-down")) {
                    $(this).removeClass("fa-chevron-down").addClass("fa-chevron-up");
                    el.slideUp(200);
                }
                else {
                    $(this).removeClass("fa-chevron-up").addClass("fa-chevron-down");
                    el.slideDown(200);
                }
            });
            $(".snip0018").click(function () {
                $(".snip0018").css("border-color", "#e1e1e1");
                $(this).css("border-color", "#1fb5ad");
            });
            $(".slidingdiv > .slidbar > .up").click(function () {
                $(this).toggleClass("down");
                $(".filed_cont").toggleClass("filedhight");
            });
            //$('.panel .tools .fa-times').click(function () {
            //    $(this).parents(".panel").parent().remove();
            //});
            // tool tips
            $('.tooltips').tooltip();
            // popovers
            $('.popovers').popover();
            //});
        },
        gotoTop: function () {
            if ($('#back-to-top').length) {
                var scrollTrigger = 100, // px
                backToTop = function () {
                    var scrollTop = $(window).scrollTop();
                    if (scrollTop > scrollTrigger) {
                        $('#back-to-top').addClass('show');
                    }
                    else {
                        $('#back-to-top').removeClass('show');
                    }
                };
                backToTop();
                $(window).on('scroll', function () {
                    backToTop();
                });
                $('#back-to-top').on('click', function (e) {
                    e.preventDefault();
                    $('html,body').animate({
                        scrollTop: 0
                    }, 700);
                });
            }
        }
    };
})(jQuery);
//}
var FixedTableHeaderScript = (function ($) {
    return {
        fixMe: function (table) {
            console.log("this this: ", table);
            return table.each(function () {
                var $this = $(this), $t_fixed;
                console.log("11111111111111");
                function init() {
                    $this.wrap('<div class="container" />');
                    $t_fixed = $this.clone();
                    $t_fixed.find("tbody").remove().end().addClass("fixed").insertBefore($this);
                    console.log("22222222222222222222222222222222");
                    resizeFixed();
                }
                function resizeFixed() {
                    console.log("33333333333333333333333333333333333");
                    $t_fixed.find("th").each(function (index) {
                        $(this).css("width", $this.find("th").eq(index).outerWidth() + "px");
                    });
                }
                function scrollFixed() {
                    console.log("4444444444444444444444444444444444444444444444");
                    console.log("this: ", this);
                    var offset = $(this).scrollTop(), tableOffsetTop = $this.offset().top, tableOffsetBottom = tableOffsetTop + $this.height() - $this.find("thead").height();
                    if (offset < tableOffsetTop || offset > tableOffsetBottom)
                        $t_fixed.hide();
                    else if (offset >= tableOffsetTop && offset <= tableOffsetBottom && $t_fixed.is(":hidden"))
                        $t_fixed.show();
                }
                $(window).resize(resizeFixed);
                $(window).scroll(scrollFixed);
                init();
            });
        }
    };
})(jQuery);
//# sourceMappingURL=scripts.js.map